import * as React from 'react';
import { FormTextField, TextFieldProps } from 'ui';
import { IconButton } from 'omakase';
import { IconEye, IconEyeOff } from '@tock/icons';
import { InputAdornment } from '@material-ui/core';

export const FormPasswordField: React.FunctionComponent<TextFieldProps> = ({
  fullWidth,
  name = 'password',
  id = 'password',
  placeholder = 'Password',
  label = 'Password',
  ...rest
}) => {
  const [showPassword, setShowPassword] = React.useState<boolean>(false);

  const handleClickShowPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <FormTextField
      fullWidth={fullWidth}
      name={name}
      id={id}
      placeholder={placeholder}
      autoComplete="current-password"
      type={showPassword ? 'text' : 'password'}
      label={label}
      inputProps={{
        'data-testid': 'password-input',
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              variant="ghost"
              size="medium"
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              type="button"
            >
              {showPassword ? <IconEye /> : <IconEyeOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
};
